// eslint-disable-next-line no-restricted-imports
import { useParams } from 'react-router-dom';

import { AppPathWithPathParams } from '../appPaths';

import { UseAppPathParamsResult } from './useAppPathParams.types';

/**
 * A hook that lets you work with the path params associated with an app path.
 * Reading path params should in turn be done through this hook as it
 * facilitates complete type-safety.
 */
export const useAppPathParams = <TPath extends AppPathWithPathParams>(
  _path: TPath,
): UseAppPathParamsResult<TPath> => {
  const params = useParams<UseAppPathParamsResult<TPath>>();
  return params;
};
